import { Action } from "../../store/types";
import { Product, Category } from "../../models";
import * as actions from "./actions";

export interface Step1State {
  categories: Category[];
  isCategoriesLoading: boolean;
  chosenProduct?: Product;
  chosenCategory?: Category;
}

const initState: Step1State = {
  categories: [],
  isCategoriesLoading: false,
  chosenProduct: undefined,
  chosenCategory: undefined,
};

export default function(
  state = initState,
  { type, payload }: Action,
): Step1State {
  switch (type) {
    case actions.SET_CATEGORIES:
      return { ...state, categories: payload };
    case actions.SET_CATEGORIES_LOADING:
      return { ...state, isCategoriesLoading: payload };
    case actions.SET_CHOSEN_PRODUCT:
      return { ...state, chosenProduct: payload };
    case actions.SET_CHOSEN_CATEGORY:
      return { ...state, chosenCategory: payload };
    case actions.RESET:
      return initState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/Step1/reducer.ts